import store from '../store';
import { vue } from '../main';

export default function admin({ next, router }) {
  if (!store.getters.isAdmin) {
    vue.$snotify.error('UNAUTHORIZED');
    return router.push({ name: 'home' });
  }

  return next();
}
